import { render, staticRenderFns } from "./TodosApp.vue?vue&type=template&id=e2cb7bf8&scoped=true&"
import script from "./TodosApp.vue?vue&type=script&lang=js&"
export * from "./TodosApp.vue?vue&type=script&lang=js&"
import style0 from "./TodosApp.vue?vue&type=style&index=0&id=e2cb7bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cb7bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2cb7bf8')) {
      api.createRecord('e2cb7bf8', component.options)
    } else {
      api.reload('e2cb7bf8', component.options)
    }
    module.hot.accept("./TodosApp.vue?vue&type=template&id=e2cb7bf8&scoped=true&", function () {
      api.rerender('e2cb7bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/todos/TodosApp.vue"
export default component.exports